import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import HeroTitle from '../HeroTitle';
import {
    getDayOfTheMonth,
    getDayOfWeek,
    getFormattedTime,
    getTheMonth
} from '../../helpers/dateTimeHelpers';

const PreRaceInfo = ({ title, raceName, raceDate, prize, children }) => {
    const weekday = getDayOfWeek(raceDate);
    const time = getFormattedTime(raceDate);
    const dayOfMonth = getDayOfTheMonth(raceDate);
    const month = getTheMonth(raceDate);

    return (
        <Styled.Wrapper>
            <HeroTitle title={title} prize={prize} />
            <Styled.RulesWrapper>
                <Styled.Rules>
                    <Styled.RulesTitle>How does it work?</Styled.RulesTitle>
                    <Styled.Rule>
                        <Styled.RulesNumber>1</Styled.RulesNumber> Enter the{' '}
                        <Styled.RulesStrong>
                            {title} Sweepstake
                        </Styled.RulesStrong>{' '}
                        competition by{' '}
                        <Styled.RulesStrong>4:00pm </Styled.RulesStrong> on{' '}
                        {weekday} {dayOfMonth} {month}, and we will draw you a
                        horse at random. It&apos;s completely{' '}
                        <Styled.RulesStrong>free to enter.</Styled.RulesStrong>
                    </Styled.Rule>
                    <Styled.Rule>
                        <Styled.RulesNumber>2</Styled.RulesNumber> If your horse
                        wins the{' '}
                        <Styled.RulesStrong>
                            {time} {raceName} race
                        </Styled.RulesStrong>{' '}
                        on {weekday} {dayOfMonth} {month}, you will be entered
                        into a Prize Draw to win{' '}
                        <Styled.RulesStrong>{prize}!</Styled.RulesStrong>
                    </Styled.Rule>
                </Styled.Rules>
            </Styled.RulesWrapper>
            {children}
        </Styled.Wrapper>
    );
};

PreRaceInfo.propTypes = {
    title: PropTypes.string.isRequired,
    raceName: PropTypes.string.isRequired,
    raceDate: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default PreRaceInfo;
